export class GtfsApiError extends Error {
  /** @type {string[] | undefined} */
  errorMessages;

  constructor(message, errors) {
    super(message);
    this.name = "GtfsApiError";
    this.errorMessages = errors?.map(this._buildErrorMessage.bind(this));
  }

  _buildErrorMessage(error) {
    let errorMessage = error?.title ?? this.message;
    if (error?.detail) {
      if (errorMessage) errorMessage += ": ";
      errorMessage += error.detail;
    }
    return `${this.name}: ${errorMessage}`;
  }
}
